import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  connect() {
    this.showNotifications()
  }

  showNotifications() {
    const notifications = []

    // Check for noindex
    if (document.querySelector('[content="noindex"]')) {
      notifications.push({
        message: 'Внимание! Страница помечена как noindex',
        color: 'red'
      })
    }

    // Check for canonical URL
    const canonicalTag = document.querySelector('link[rel="canonical"]')
    if (canonicalTag) {
      const canonicalUrl = canonicalTag.getAttribute('href')

      notifications.push({
        message: `Каноническая ссылка: <a href="${canonicalUrl}" style="color: white;">${canonicalUrl}</a>`,
        color: 'blue'
      })
    }

    // Display notifications in the container
    notifications.forEach((notification, index) => {
      const notificationDiv = document.createElement('div')
      notificationDiv.style.cssText = `
        background: ${notification.color};
        color: white;
        padding: 10px;
        opacity: 0.8;
      `
      notificationDiv.innerHTML = notification.message

      // Prepend to show notifications from bottom to top
      this.element.prepend(notificationDiv)
    })
  }
}
